import { JsonObject, JsonProperty } from 'json2typescript';

import { Group } from './group';

/**
 * ç§å®¤
 *
 * å¨å°ç»çåºç¡ä¸è¿è¡æ©å±
 */
@JsonObject
export class Dept extends Group {
  /**
   * ç¶ç§å®¤çId, å¦ææ²¡æç¶ç§å®¤çè¯, parentIdå³ä¸º0/undefined/null
   */
  @JsonProperty('parentId', Number)
  parentId: number = undefined;
}
